<template>
  <div id="app">
    <the-nav />
    <div class="main-layout">
      <router-view class="main" />
    </div>

    <the-modal />
    <the-loading />
  </div>
</template>

<script>
import TheNav from '@/components/TheNav'
import TheModal from '@/components/TheModal/index'
import TheLoading from '@/components/TheLoading/index'

export default {
  components: {
    TheNav,
    TheModal,

    TheLoading
  },

  created () {
    this.$store.commit('toast/setAttr', {
      name: 'vm',
      value: this
    })
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  box-sizing: border-box;

}

.main {
  &-layout {
    margin: 0 auto;
    max-width: 1080px;
  }

  margin: 1rem;
  margin-top: 3rem;
  margin-bottom: 3rem;
}
</style>
